import { distance } from './geometrie.js';
/** Le nom d'un outil, tel que la barre l'écrit. */
export const LIBELLE_OUTIL = {
    choisir: 'Choisir',
    point: 'Point',
    segment: 'Segment',
    droite: 'Droite',
    demi_droite: 'Demi-droite',
    cercle: 'Cercle',
    polygone: 'Polygone',
    angle: 'Angle',
    mesurer: 'Mesurer',
    texte: 'Texte',
    milieu: 'Milieu',
    perpendiculaire: 'Perpendiculaire',
    parallele: 'Parallèle',
    mediatrice: 'Médiatrice',
    bissectrice: 'Bissectrice',
    intersection: 'Intersection',
    compas: 'Compas',
    translation: 'Translation',
    rotation: 'Rotation',
    reflexion: 'Réflexion',
    homothetie: 'Homothétie',
    fonction: 'Fonction',
    demi_plan: 'Demi-plan',
    table_valeurs: 'Table de valeurs',
    vecteur: 'Vecteur',
    solide: 'Solide',
    marquer: 'Marquer',
    deplier: 'Déplier',
    esquisse: 'Esquisse',
};
/**
 * L'outil, dit comme une consigne le demande : « le compas », « la règle »,
 * « l'outil Perpendiculaire ». Un instrument se nomme par lui-même ; un outil
 * de l'atelier qui n'a pas d'équivalent sur la table, par son nom.
 */
export function outilDansLaConsigne(outil) {
    switch (outil) {
        case 'compas':
            return 'le compas';
        case 'segment':
        case 'droite':
            return 'la règle';
        default:
            return `l’outil ${LIBELLE_OUTIL[outil]}`;
    }
}
/**
 * LA PHRASE DE LA MÉTHODE (arbitrage A2) : l'outil exclu que l'élève a pris,
 * et — si la consigne le dit — celui qu'elle demandait.
 *
 *   « Construite avec l'outil Médiatrice, la consigne demandait le compas. »
 *   « Construite avec l'outil Médiatrice, que la consigne excluait. »
 *
 * `employes` : les outils exclus vus par le vérificateur, dans l'ordre du
 * document (`VerificationConstruction.methode`). Le premier parle. `null` :
 * rien à dire.
 */
export function phraseDeMethode(employes, outilDemande) {
    const premier = employes[0];
    if (premier === undefined)
        return null;
    const pris = `Construite avec l’outil ${LIBELLE_OUTIL[premier.outil]}`;
    return outilDemande === null
        ? `${pris}, que la consigne excluait.`
        : `${pris}, la consigne demandait ${outilDansLaConsigne(outilDemande)}.`;
}
/**
 * Ce que l'élève lit quand ses arcs ne se coupent pas : le constat, puis le
 * geste qui le répare. Jamais « faux ».
 */
export const PHRASE_ARCS_DISJOINTS = 'Tes arcs ne se coupent pas : ouvre davantage ton compas, plus que la moitié du segment.';
/** Deux cercles se coupent-ils (ou se touchent-ils), à `tolerance` près ? */
function seCoupent(a, b, tolerance) {
    const d = distance(a.centre, b.centre);
    return d <= a.rayon + b.rayon + tolerance && d >= Math.abs(a.rayon - b.rayon) - tolerance;
}
/**
 * LES ARCS QUI NE SE COUPENT PAS (CONCEPTION § 3, « ouverture de compas trop
 * petite »). Vrai quand l'élève a tracé AU COMPAS (`cercle_report`) au moins
 * deux arcs de centres distincts, et qu'AUCUNE paire d'entre eux ne se coupe —
 * à la tolérance de distance près, pour qu'un arc qui frôle l'autre ne soit pas
 * reproché à l'élève. Un seul arc, ou des arcs qui se coupent : faux.
 *
 * Seuls les arcs de l'ÉLÈVE comptent, masqués compris (un trait de
 * construction reste une construction). La résolution est celle du document.
 */
export function arcsQuiNeSeCoupentPas(doc, resolue, tolerance) {
    const arcs = [];
    for (const o of Array.isArray(doc?.objets) ? doc.objets : []) {
        if (o.def.type !== 'cercle_report')
            continue;
        const r = resolue.objets.get(o.id);
        if (r?.genre === 'cercle')
            arcs.push({ id: o.id, centre: r.centre, rayon: r.rayon });
    }
    let paires = 0;
    for (let i = 0; i < arcs.length; i += 1) {
        for (let j = i + 1; j < arcs.length; j += 1) {
            const a = arcs[i];
            const b = arcs[j];
            if (a === undefined || b === undefined)
                continue;
            /* Deux arcs du même centre ne sont pas deux arcs à faire se couper. */
            if (distance(a.centre, b.centre) <= tolerance)
                continue;
            paires += 1;
            if (seCoupent(a, b, tolerance))
                return false;
        }
    }
    return paires > 0;
}
//# sourceMappingURL=outils-construction.js.map